import { Provider } from "@angular/core";
import { BUILDPANELELEMENT_MODAL_PROVIDER } from "./components/templates/layouts/build-panel-element-modal/build-panel-element-modal.component";
import { TEMPLATEFIELDADD_MODAL_PROVIDER } from "./components/templates/template-fields/template-field-add/template-field-add.component";

export const CONFIG_PROVIDERS: Provider[] = [
	BUILDPANELELEMENT_MODAL_PROVIDER,
	TEMPLATEFIELDADD_MODAL_PROVIDER
];